import Dbm from "dbm";
import Website from "../../../index.js";

export default class Heart extends Website.game.gameplay.gameobjects.Coin {
    _construct() {
        super._construct();
    }

    _getLabel() {
        return "heart";
    }
}